<template>
    <div class="electricty-wrap">
        <div class="total-wrap">
            <div class="total-gas item">
                <div class="mark">
                    <i class="iconfont ">&#xe655;</i>
                </div>
                <div class="icon-wrap icon-g">
                    <i class="iconfont ">&#xe655;</i>
                </div>
                <div class="label">
                    <div>{{totalElectrity}}</div>
                    <div>总用电量(T)</div>
                </div>
            </div>
            <div class="total-cost item">
                <div class="mark">
                    <i class="iconfont ">&#xe655;</i>
                </div>
                <div class="icon-wrap icon-c">
                    <i class="iconfont">&#xe634;</i>
                </div>
                <div class="label">
                    <div>{{totalCost}}</div>
                    <div>总用电费用(￥)</div>
                </div>
            </div>
            <div class="total-heat item">
                <div class="mark">
                    <i class="iconfont ">&#xe655;</i>
                </div>
                <div class="icon-wrap icon-h">
                    <i class="iconfont">&#xe600;</i>
                </div>
                <div class="label">
                    <div>{{priceAverage}}</div>
                    <div>度电均价(￥)</div>
                </div>
            </div>
        </div>

        <div class="chart-wrap">
            <div class="chart">
                 <div class="mark">
                    <i class="iconfont ">&#xe655;</i>
                </div>
                <div class="chart-content fee_chart">

                </div>
            </div>
            <div class="chart">
                <div class="mark">
                    <i class="iconfont ">&#xe655;</i>
                </div>
                <div class="chart-content quantity_chart">
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/** 费用饼图 */
const feeOption = {
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
  grid: {
    left: "8%",
    right: "0",
    bottom: "1%",
    containLabel: true,
  },
  legend: {
    // orient: "vertical",
    icon: "circle",
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: "14",
    },
    itemGap: 100, // 设置legend的间距
    itemWidth: 30, // 设置宽度
    itemHeight: 14, // 设置高度
    data: ["谷电量", "尖电量", "峰电量"],
    formatter: function (name) {
      var index = 0;
      var labels = ["谷电量", "尖电量", "峰电量"];
      var counts = [1.542, 1.021, 0.894];
      labels.forEach(function (value, i) {
        if (value == name) {
          index = i;
        }
      });
      return counts[index] + "¥/kWh\n" + name;
    },
  },
  series: [
    {
      name: "用量",
      type: "pie",
      selectedMode: "single",
      radius: [0, "56%"],
      center: ["50%", "62%"],
      label: {
        position: "inner",
        formatter: "{b}\n\n{d}%\n\n{c}kWh",
        fontSize: "12",
      },
      labelLine: {
        show: false,
      },
      data: [
        {
          value: 3453.945,
          name: "谷电量",
          itemStyle: { color: "#4FC953", fontSize: 12 },
        },
        {
          value: 678.876,
          name: "尖电量",
          itemStyle: { color: "#FF5962", fontSize: 12 },
        },
        {
          value: 2876.943,
          name: "峰电量",
          itemStyle: { color: "#FEC54A", fontSize: 12 },
        },
      ],
    },
    {
      name: "价格",
      type: "pie",
      radius: ["65%", "75%"],
      center: ["50%", "62%"],
      label: {
        formatter: "{b}：\n{c}￥\n{d}%",
        color: "#666",
        fontSize: "14",
      },
      labelLine: {
        //引导线设置
        normal: {
          show: true, //引导线显示
          // smooth: 0.2,//平滑程度
          lineStyle: {
            length: 20, //引导线的长度
            width: 2,
            type: "dotted",
          },
        },
      },
      data: [
        {
          value: 5893.84,
          name: "谷电量",
          itemStyle: { color: "#4FC953", fontSize: "12" },
        },
        {
          value: 678.876,
          name: "尖电量",
          itemStyle: { color: "#FF5962", fontSize: "12" },
        },
        {
          value: 82487.77,
          name: "峰电量",
          itemStyle: { color: "#FEC54A", fontSize: "12" },
        },
      ],
    },
  ],
};
// 引入echarts图表
import echarts from 'echarts/lib/echarts';

export default {
    name:"electricty",
    props:["reportdata"],
    computed:{
        // 总用电
        totalElectrity:function(){
            let total=0.0;
            let SumFlux=this.reportdata.total.SumFlux;
            let quantity=SumFlux.quantity;
            for(let itN in quantity){
                let temp=quantity[itN];
                total+=temp;
            }
            return total;
        },
        // 总费用
        totalCost:function(){
            let total=0.0;
             let SumFlux=this.reportdata.total.SumFlux;
            let fee=SumFlux.fee;
            for(let itN in fee){
                let temp=fee[itN];
                total+=temp;
            }
            return total.toFixed(2);
        },
        // 用电均价，总费用/总用电
        priceAverage:function(){
            let price=0.0;
            price=(this.totalCost/this.totalElectrity).toFixed(3);

            return price;
        }
    },
    mounted(){
       this.init_fee_chart();
    },
    methods:{
        // 初始化费用图表
        init_fee_chart(){
            let reportdata=this.reportdata;
            console.log(reportdata);

            let chartDom=this.$el.querySelector(".fee_chart"); // 获取Dom节点
            console.log(chartDom);
            echarts.init(chartDom).setOption(feeOption, true);
        }
    }
}
</script>

<style lang="scss">
.electricty-wrap{

    .mark{
        position: absolute;
        left: 10px;
        top:10px;
        color: #FF5962;
    }

    .total-wrap{
        display: flex;

        .item{
            flex:1;
            justify-content: center;
            position: relative;
            display: flex;
            padding:20px;
            background: #fff;
            margin:5px;
            border-radius: 10px;
           
            .icon-wrap{
                width:50px;
                height: 50px;
                border-radius: 40px;
                margin-right: 10px;
                line-height: 50px;
                text-align: center;
                color: #fff;

                i{
                    font-size: 30px;
                }
                
                &.icon-g{
                    background: #FEC54A;
                }

                &.icon-h{
                    background: #FE5D66;
                }

                &.icon-c{
                    background: #58CC5C;
                }
            }

            .label{
                & div:first-child{
                    margin-top:6px;
                }
            }

        }
    }
    /** 图表 */
    .chart-wrap{
        border-radius: 10px;
        margin:10px 5px;
        position: relative;
        display: flex;
        min-height: 400px;

        .chart{
            flex:1;
            background: #fff;
            margin: 5px;
            position: relative;
            border-radius: 5px;
            padding: 10px;

            .chart-content{
                width: 100%;
                height: 100%;
            }
        }
    }

}
</style>